<template>
  <div class="flex-child toggle-group">
    <base-button class="toggle__left" @click="pickBookingType('causal')"
      >Casual</base-button
    >
    <base-button class="toggle__right" @click="pickBookingType('recurring')"
      >Recurring</base-button
    >
  </div>
</template>

<script>
export default {
  data() {
    return {
      isRecurring: false,
      bookingType: 'causal',
    };
  },

  computed: {
    styles: function () {
      if (this.isRecurring) {
        return {
          'background-color': '#474646',
        };
      } else {
        return {
          'background-color': '#00509e',
        };
      }
    },
  },

  methods: {
    pickBookingType(type) {
      this.bookingType = type;
      if (type == 'causal') {
        this.isRecurring = false;
      } else {
        this.isRecurring = true;
      }
      this.$emit('booking-type', this.bookingType);
    },
  },
};
</script>

<style scoped>
div {
  margin-right: 0rem;
  max-width: 40rem;
  word-wrap: break-word;
}

.toggle__left {
  border-top-left-radius: 35px;
  border-bottom-left-radius: 35px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  border: 0px hidden #ccc;
  background-color: inherit;
}

.toggle__right {
  border-top-right-radius: 35px;
  border-bottom-right-radius: 35px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  border: 0px hidden #ccc;
}
</style>
